import React, { Component } from 'react'
import axios from 'axios';
import {axiosEH} from '../common/functions'
import jwtUser from '../../jwtUser';
import Pressoptions from './pressoptions'

export default class AddClass extends Component {
  constructor() {
    super()
    this.state = {
      className: '',
      schoolID: '',
      pressID: '',
      students: '',
      tbTaskType: 'SB',
      spellingTimeoutSec: '',
      taskDueDays: '',
      optionsArr: [],
      statusMsg: '',

      //defaultTBTaskType: sessionStorage.getItem('sc-tbTaskType')!=null?sessionStorage.getItem('sc-tbTaskType'): process.env.REACT_APP_TB_DEFAULT_TASKTYPE,
      defaultTBTaskType: 'SB',
      defaultSBTimeoutSec: sessionStorage.getItem('sc-spellingTimeoutSec')!=null?sessionStorage.getItem('sc-spellingTimeoutSec'): process.env.REACT_APP_SPELLING_TIMEOUT_SEC,
      defaultTaskDueDays: sessionStorage.getItem('sc-taskDueDays')!=null?sessionStorage.getItem('sc-taskDueDays'): process.env.REACT_APP_TASK_DUE_DAYS,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleChangeSID = this.handleChangeSID.bind(this)
  }

  //options = ["HTML","CSS", "JavaScript"];

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
  }

  handleChangeSID(event) {
    const po = sessionStorage.getItem('pressoptions');
    this.setState({ [event.target.name]: event.target.value.trim()});

    // get pid options
    if ( po == null || po == '' || po == '[]' ) {
      this.setState({ statusMsg: 'pressoptions not exist or empty'})
    } else {
      let obj = JSON.parse(po);
      obj = obj.filter(obj => { 
        return obj.schoolID === event.target.value.trim();  
      });
      obj = obj.map(a => a.pressID);
      this.setState({ optionsArr: obj})
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let url = process.env.REACT_APP_BASEURL + '/userclasses/addclass';
    const user = jwtUser(); // get user token

    //console.log(this.state.className, this.state.schoolID, this.state.pressID, this.state.tbTaskType);


    // inputs required
    if (!this.state.className || !this.state.schoolID || !this.state.pressID || !this.state.students) {
      this.setState({ statusMsg: `All four red color inputs are required` })
      return;
    }

    axios.post(url, {
      username: user.username,
      className: this.state.className,
      schoolID: this.state.schoolID,
      pressID: this.state.pressID,
      students: this.state.students,

      tbTaskType: this.state.tbTaskType?this.state.tbTaskType:this.state.defaultTBTaskType,
      spellingTimeoutSec: this.state.spellingTimeoutSec?this.state.spellingTimeoutSec : this.state.defaultSBTimeoutSec,
      taskDueDays: this.state.spellingTimeoutSec?this.state.spellingTimeoutSec: this.state.defaultTaskDueDays,
    },
      { headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {  // ''
        if (res.status == 200) {
          this.setState({
            statusMsg: res.data,
          })
          if (res.data == 'success') {
            sessionStorage.removeItem("classList");
            window.location.reload();
          }
        }
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  }

  render() {
    // get default configs for PH
    const ttPH = `textbook task types (lastSet ${this.state.defaultTBTaskType}) ...`; 
    const tdhPH = `taskDueDays (lastSet ${this.state.defaultTaskDueDays})`; 
    const sbPH = `spellingTimeoutSec (lastSet ${this.state.defaultSBTimeoutSec})`;
    return (
      <section className="login-form is-medium mx-5">
        <Pressoptions />

        {!this.state.statusMsg && <div>
          <input className="input is-danger" type="text" name="className" placeholder="className"
            value={this.state.className.trim()}
            onChange={this.handleChange}>
          </input>
          <div className="select is-danger" style={{width:'80%'}}>
            <select name='schoolID' onChange={this.handleChangeSID} >
                <option >schoolID options ...</option>
                {['K-12','ES','MS','HS'].map((option, index) => {
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
          </div>        
          <div className="select is-danger" style={{width:'80%'}}>
            <select name='pressID' onChange={this.handleChange} >
                <option >PressID options ...</option>
                {this.state.optionsArr.map((option, index) => {
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
          </div>
          <input className="input is-danger" type="text" name="students"
            placeholder='students(example: Adam, Juliet)'
            value={this.state.students.trim()}
            onChange={this.handleChange}>
          </input>  
          {/*
          <div className="select" style={{width:'80%'}}>
            <select name='tbTaskType' onChange={this.handleChange}>
                <option >{ttPH}</option>
                {['PA+SB','PA','SB'].map((option, index) => {
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
          </div>
          */}
          <input className="input" type="text" name="taskDueDays"
            placeholder={tdhPH}
            value={this.state.taskDueDays?this.state.taskDueDays.trim():this.state.taskDueDays}
            onChange={this.handleChange}>
          </input>    
          <input className="input" type="text" name="spellingTimeoutSec"
            placeholder={sbPH}
            value={this.state.spellingTimeoutSec}
            onChange={this.handleChange}>
          </input>
          <button className="button is-success" onClick={this.handleSubmit}>
            +Class
          </button>
        </div> }

        <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}